<template>
    <PDFView 
    v-if="currentFrame?.template?.pdfSource"
    :source="currentFrame?.template?.pdfSource" 
    :page="-1" 
    @loaded="onPdfLoaded" 
    />

    <div class="mb-0 elevation-1 text-h5 text-center ">
        <p>Designer 
            <v-icon class="mr-2">mdi-brush-outline</v-icon> 
            <v-icon 
             v-if="currentFrame?.template?.pdfSource" 
             class="mr-2" 
             size="small" 
             v-tooltip:end="'Neu generieren'"
             @click="generateAgainSuggestions">mdi-sync</v-icon>
        </p>
        <div v-if="currentFrame?.template?.pdfSource != undefined"
             class="mt-1 py-2 text-caption d-flex justify-center align-center gap-2"
             v-motion-pop-visible 
             >
            <div class="font-weight-light">Empfehlung:</div>
            <v-chip class="mx-1" color="green-darken-2" small>Am besten</v-chip> 
            <v-chip class="mx-1" color="orange-darken-3" small>Mittel</v-chip>
            <v-chip class="mx-1" color="red-darken-3" small>Niedig</v-chip> 
        </div>
    </div>
    <v-sheet 
     height="550px" max-height="550px" 
     class="overflow-y-auto hidden-scrollbar d-flex flex-column bg-blue-grey-lighten-5">

      <!-- Progress Icon for updating suggestions-->
     <div v-if="isInProcessOfNewGenerating" class="d-flex justify-center align-center flex-column" style="height: 50vh;">
        <v-progress-circular
            indeterminate
            :size="70"
            :width="7"
            color="green-lighten-1"
        >
        <v-icon class="mr-2" size="x-large">mdi-cogs</v-icon>
        </v-progress-circular>
        <p class="mt-10 text-h6 text-center">Layout-Vorschläge werden aktualisiert...</p> 
    </div>

    <div v-if="currentFrame?.template?.pdfSource != undefined && !isInProcessOfNewGenerating" class="d-flex flex-column align-center">
        <div v-for="page in totalPages" :key="page" class="photo-item mb-4">
         <div class=".pdf-container" v-motion-pop-visible >
            <v-chip
                :color="getScoreColor(currentFrame.template.slideTemplate[page].score)" 
                class="my-n2"
                label
                small
            >
                Score: {{ currentFrame.template.slideTemplate[page].score === 1 ? '1,0' : currentFrame.template.slideTemplate[page].score }}
            </v-chip>
            <!-- <p class="pt-0 text-left text-h6 font-weight-light"> score {{ currentFrame.template.slideTemplate[page].score }}</p> -->
            <PDFView 
                class="mt-2 elevation-10 rounded-xl h-auto" 
                :style="{ cursor: 'pointer' }" 
                :source="currentFrame?.template?.pdfSource"
                :page="page" 
                :scale="1.5"
                @click="selectedSuggestedLayout(page)"
            />
         </div>
        </div>
    </div>

    <!-- Progress Icon for creating suggestions -->
    <div v-if="isInProcess" class="d-flex justify-center align-center flex-column" style="height: 50vh;">
        <v-progress-circular
            indeterminate
            :size="70"
            :width="7"
            color="blue-grey-darken-1"
        >
        <v-icon class="mr-2" size="x-large">mdi-cogs</v-icon>
        </v-progress-circular>

        <p v-if="isInProcess" 
           class="mt-10 text-h6 text-center">
           Layout-Vorschläge werden generiert...
        </p> 
    </div>

    <!-- Button to generate a layout-suggestions -->
    <div v-if="!isInProcess && !currentFrame?.template?.pdfSource" class="d-flex justify-center align-center flex-column" style="height: 50vh;">
        <v-btn 
          class="ma-2 pa-2 elevation-5 font-weight-light" 
          size="large" 
          border="dashed thin" 
          @click="generateLayoutsSuggestions">
            <template v-slot:prepend>
                <v-icon color="#1DE9B6">mdi-creation-outline</v-icon>
            </template>
            Generieren
            <template v-slot:append>
                <v-icon color="#FFC107">mdi-creation-outline</v-icon>
            </template>
        </v-btn>
    </div>
    </v-sheet>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import PDFView from 'vue-pdf-embed';
import { Frame } from '@/types/frame';

export default defineComponent({
    name: 'SlideDesignPreview-Componenten',

    props:{
        currentFrame: Object as () => Frame | null,
        isInProcess: Boolean,
        isInProcessOfNewGenerating: Boolean,
    },
    components: {
        PDFView,
    },
    data() {
        return {
            totalPages: 0 as number,
        };
    },
    methods: {
        generateLayoutsSuggestions(){
          this.$emit("generateLayoutsSuggestions", true);
        },
        selectedSuggestedLayout(page : number){
          this.$emit("selectedSuggestedLayout", page)
        },
        generateLayoutSuggestionsForPage(page : number){
            this.$emit("generateLayoutSuggestionsForPage", page)
        },
        generateAgainSuggestions(){
            this.$emit("generateAgainSuggestions", true)
        },
        onPdfLoaded(pdf: any) {
            this.totalPages = pdf.numPages;
        },
        getScoreColor(score : number | undefined | null): string {
            if (score === undefined || score === null) {
                return 'primary';
            } else if (score < 0.6) {
                return 'red-darken-3';
            } else if (score < 0.92) {
                return 'orange-darken-3';
            } else {
                return 'green-darken-2';
            }
        }
    },
    created() {
    },
});
</script>

<style scoped>
.pdf-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; 
  background-color: #f5f5f5; 
}
</style>
